import { type GroupClassIllustrations, TagColor } from '@equip.health/ui';
import { SYSTEM_TIME_ZONE } from '../util/calendar.util';

export enum GroupClassListTab {
  MY_GROUPS = 'my-groups',
  ACTIVE_GROUPS = 'active',
  WEEKLY = 'weekly',
  ARCHIVE = 'archive',
}

export enum GroupClassTabTitle {
  MY_GROUPS = 'My groups',
  ACTIVE_GROUPS = 'Active groups',
  WEEKLY_VIEW = 'Weekly view',
  ARCHIVE = 'Archive',
}

export enum GroupClassListTypeEnum {
  MY_GROUPS = 'my-groups',
  ARCHIVE = 'archive',
  ACTIVE = 'active',
  WEEKLY = 'weekly',
}

export enum GroupTypeEnum {
  ORIENTATION = 'ORIENTATION',
  EDUCATION = 'EDUCATION',
  COPING_SKILLS = 'COPING_SKILLS',
  SUPPORT = 'SUPPORT',
  WORKSHOP = 'WORKSHOP',
}

export enum GroupSectionFrequency {
  DOES_NOT_REPEAT = 'DOES_NOT_REPEAT',
  EVERY_WEEKDAY = 'EVERY_WEEKDAY',
  EVERY_DAY = 'EVERY_DAY',
  WEEKLY = 'WEEKLY',
  EVERY_OTHER_WEEK = 'EVERY_OTHER_WEEK',
  EVERY_4_WEEKS = 'EVERY_4_WEEKS',
  FIRST_OF_EVERY_MONTH = 'FIRST_OF_EVERY_MONTH',
}

export const GroupTypeTagColorMapper: Record<GroupTypeEnum, TagColor> = {
  [GroupTypeEnum.COPING_SKILLS]: TagColor.orange,
  [GroupTypeEnum.EDUCATION]: TagColor.teal,
  [GroupTypeEnum.SUPPORT]: TagColor.pink,
  [GroupTypeEnum.ORIENTATION]: TagColor.purple,
  [GroupTypeEnum.WORKSHOP]: TagColor.periwinkle,
};

export const GET_GROUP_CLASS_PAGE_SIZE_V2 = 20;
export const PROMOTE_THIS_GROUP_IN_EQUIP_APP =
  'Promote this group in the Equip App';

export const GroupClassAttendeeTypes: GroupClassAttendeeType[] = [
  'Patients',
  'Supports',
];

export const DEFAULT_FORM_STATE: GroupFormState = {
  title: '',
  iconName: undefined,
  description: '',
  attendeeRoles: [],
  treatmentPrograms: [],
  treatmentModalities: [],
  diagnoses: [],
  ageRanges: [],
  groupTypeCode: '',
  isSensitive: false,
  isCore: false,
};

export const MOCK_GROUP_RESPONSE = {
  data: {
    title: 'title',
    iconName: 'MESSAGE' as GroupClassIllustrations,
    description: 'description',
    attendeeRoles: ['PATIENTS', 'SUPPORTS'],
    treatmentPrograms: ['EQUIP_TREAT', 'FREEFORM'],
    treatmentModalities: ['CBT_AR', 'FBT'],
    diagnosis: ['AN_R'],
    ageRanges: ['TEEN'],
    groupTypeCode: GroupTypeEnum.WORKSHOP,
    isSensitive: false,
    isCore: true,
  },
};

export const GROUP_CLASS_SEARCH_PLACEHOLDER_BY_TAB = {
  ACTIVE: 'Search groups',
  ARCHIVE: 'Search groups',
  MY_GROUPS: 'Search my groups',
  MY_SECTIONS: 'Search groups',
  ALL_GROUPS: 'Search groups',
};

export const DEFAULT_SECTION_FORM_STATE = {
  hosts: [],
  frequency: '',
  dayOfWeek: '',
  sessionDateTime: null,
  timezone: SYSTEM_TIME_ZONE,
  duration: 0,
  length: '',
  startDate: '',
  endDate: '',
  startTime: '',
  maximumAttendees: 0,
  mustAttendAll: false,
  isWebinar: false,
  showDate: false,
  showMaximumAttendees: false,
};

export const DurationOptions = [
  { label: '30 mins', value: '30' },
  { label: '45 mins', value: '45' },
  { label: '60 mins', value: '60' },
  { label: '75 mins', value: '75' },
  { label: '90 mins', value: '90' },
  { label: '120 mins', value: '120' },
  { label: '180 mins', value: '180' },
];

export const DayOfWeekOptions = [
  { label: 'Monday', value: 'Monday' },
  { label: 'Tuesday', value: 'Tuesday' },
  { label: 'Wednesday', value: 'Wednesday' },
  { label: 'Thursday', value: 'Thursday' },
  { label: 'Friday', value: 'Friday' },
  { label: 'Saturday', value: 'Saturday' },
  { label: 'Sunday', value: 'Sunday' },
];

export const DAY_OF_WEEK_DISABLED_FREQUENCIES = new Set([
  'EVERY_WEEKDAY',
  'EVERY_DAY',
  'FIRST_OF_EVERY_MONTH',
]);
